import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { PRIMARY, makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { identity, middle, SCREEN_WIDTH, SCREEN_HEIGHT } from '../../tornado/utils/sizes';
import { TRANSPARENT } from '../../tornado/utils/colors';

export const titleFont = getFont(FONT.OTTAWA_1);

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  popup: makeThemeColor(TERTIARY),
  popupOverlay: makeThemeColor(TERTIARY, 0.8),
  text: makeThemeColor(PRIMARY),
};

export const POPUP_WIDTH = {
  [HD]: 672,
  [FULL_HD]: 960,
};

export const POPUP_HEIGHT = {
  [HD]: 196,
  [FULL_HD]: 232,
};

export const TITLE_WIDTH = {
  [HD]: 512,
  [FULL_HD]: 776,
};

export const TITLE_HEIGHT = {
  [HD]: 30,
  [FULL_HD]: 36,
};

export const FLEX_CONTAINER_HEIGHT = {
  [HD]: 41,
  [FULL_HD]: 56,
};

export const ICON_OFFSET = {
  [HD]: 24,
  [FULL_HD]: 24,
};

export const TEXT_OFFSET = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const BUTTONS_OFFSET = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const ICON_HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 48,
};

export const BORDER_RADIUS = {
  [HD]: 24,
  [FULL_HD]: 40,
};

export const INFO_ICON = { name: 'Warning', type: 'icon' };

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  Overlay: {
    rect: true,
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: TRANSPARENT,
  },
  Popup: {
    rect: true,
    x: SCREEN_WIDTH[screenSize] / 2 - POPUP_WIDTH[screenSize] / 2,
    y: SCREEN_HEIGHT[screenSize] / 2 - POPUP_HEIGHT[screenSize] / 2,
    w: POPUP_WIDTH[screenSize],
    h: POPUP_HEIGHT[screenSize],
    borderRadius: BORDER_RADIUS[screenSize],
    flex: { direction: 'column' },
    color: TRANSPARENT,
    Icon: {
      flexItem: { marginTop: ICON_OFFSET[screenSize] },
      mountX: 0.5,
      x: middle,
      color: colors.text[colorMode],
      iconData: {
        picto: INFO_ICON,
        viewBox: { h: ICON_HEIGHT[screenSize] },
      },
    },
    Title: {
      visible: false,
      flexItem: { marginTop: TEXT_OFFSET[screenSize] },
      mountX: 0.5,
      x: middle,
      text: {
        textColor: colors.text[colorMode],
        ...titleFont,
        verticalAlign: 'middle',
        maxLines: 1,
      },
    },
    ButtonsFlexContainer: {
      rect: true,
      visible: false,
      h: FLEX_CONTAINER_HEIGHT[screenSize],
      w: identity,
      flexItem: { marginTop: BUTTONS_OFFSET[screenSize] },
      color: TRANSPARENT,
      flex: {
        direction: 'row',
        justifyContent: 'center',
      },
      ExitButton: {
        flexItem: {
          marginRight: BUTTONS_OFFSET[screenSize],
        },
      },
    },
  },
});

export const getFinalStyle = ({ colorMode } = defaultContext) => ({
  Overlay: {
    color: colors.popupOverlay[colorMode],
  },
  Popup: {
    color: colors.popup[colorMode],
    Title: { visible: true },
    ButtonsFlexContainer: { visible: true },
  },
});
